/** The little dark speech bubble the old login form showed beside a field. */
export function Feedback({ text, top }: { text: string | null; top: number }) {
  return (
    <div className="feedbackHolder" style={{ opacity: text ? 1 : 0, top }} role={text ? "alert" : undefined}>
      <div className="arrow-left"> </div>
      <div className="feedbackText">{text}</div>
    </div>
  );
}
